import React from 'react';

const AcademyHealthAnnualResearchMeetingMinneapolisMN2025 = () => {
  return (
    <div>
      <p className='text-large text-bold'>
        2025: AHRQ QI Presentations at the 2025 AcademyHealth Annual Research Meeting, Minneapolis
        MN
      </p>
      <p>
        This presentation by AHRQ QI Program staff provided an overview of the AHRQ Quality
        Indicators and research-orientated applications of the AHRQ Quality Indicators.
      </p>
      <p>
        <strong>Development and Validation of Diagnostic Safety Quality Indicators</strong> (
        <a
          href='/Downloads/Resources/Presentations/2025/ARM_25 Diagnostic Safety QI slides.pdf'
          target='_blank'
        >
          Panel Presentation, PDF File, 4.82 MB
        </a>
        ). <br />
        Alex Bohl, Keri Calkins, Whitney Schott, James Dowell, Patrick Romano, Sharon Zhao, Judy
        George. <br />
        This presentation outlined work at AHRQ to develop a starter set of standardized measures to
        support population-level diagnostic safety surveillance. Our goal is to develop diagnostic
        excellence measures that are accessible and applicable across users, especially those with
        limited access to clinical data sources, and to provide a national reference for developing
        baseline benchmarks of population-level diagnostic safety surveillance.
      </p>
      <p>
        <strong>
          Importance Of Including Severe Maternal Morbidity (SMM) Events After Delivery
          Hospitalization
        </strong>{' '}
        (
        <a
          href='/Downloads/Resources/Presentations/2025/ARM_25_SMM post-discharge slides.pdf'
          target='_blank'
        >
          Podium Presentation, PDF File, 512 KB
        </a>
        ). <br />
        Karen Schneider, PhD, Keri Calkins, PhD, Whitney Schott, PhD, Leanna Sudhof, MD, Patrick
        Romano, MD, MPH, Haixia Xu, Judy George, PhD and Alex Bohl, PhD. <br />
        The aim of this study is to evaluate the extent to which the SMM and maternal mortality (MM)
        rates change with the inclusion of events after discharge. During the delivery
        hospitalization, the SMM rate was 87.1 per 10,000 deliveries (95% confidence interval [CI]:
        86.0-88.3), which increased to 121.8 per 10,000 (95% CI: 113.7-116.0) with the inclusion of
        SMM events through 90 days post-discharge. Over 80% of SMM events in the 90-day
        post-discharge period occurred in the first 42 days after discharge.{' '}
      </p>
      <p>
        <strong>
          ED Visits for Ambulatory Care Sensitive Conditions are More Common when Economic Resources
          and Primary Care are Scarce
        </strong>{' '}
        (
        <a href='/Downloads/Resources/Presentations/2025/ARM_25_PQE Poster.pdf' target='_blank'>
          Poster Presentation, PDF File, 659 KB
        </a>
        ). <br />
        Eric Schone, Whitney Schott, Judy George, Neetu Jain, James Dowell, Xiaojing Lin, Sheng
        Wang, Alex Bohl. <br />
        This study sought to measure the association of counties' economic conditions and access to
        ambulatory care with the Agency for Healthcare Research & Quality's Prevention Quality
        Indicators in Emergency Department (ED) Settings (PQE). We found that residents in the most
        deprived counties were significantly more likely to experience ACSC ED visits than residents
        of the least deprived.
      </p>
    </div>
  );
};

export default AcademyHealthAnnualResearchMeetingMinneapolisMN2025;
